import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierVehicleService,
  CarrierModel,
  VehicleAddByCarrierRequest,
  AnyValueModelUUID,
  VehicleManualAddRequest,
  VehicleModel,
  VehiclePhotoType,
  VehicleCargoRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierVehicleApiService {
  constructor(private apiService: CarrierVehicleService) {}

  public addVehicle(carrierId: string, body: VehicleAddByCarrierRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierModel> {
    return this.apiService.carrierVehicleAdd(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addVehicleManual(carrierId: string, body: VehicleManualAddRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierVehicleAddManual(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public parseRegistrationForVehicleCreation(carrierId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierVehicleAddRequest(carrierId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public assignDriver(vehicleId: string, driverId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierVehicleAssignDriver(vehicleId, driverId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public delete(vehicleId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierVehicleDelete(vehicleId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteVehiclePhoto(vehicleId: string, photoType: VehiclePhotoType, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.carrierVehicleDeletePhoto(vehicleId, photoType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehicleCargo(vehicleId: string, body: VehicleCargoRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.carrierVehicleEditCargo(vehicleId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehiclePhoto(vehicleId: string, photoType: VehiclePhotoType, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.carrierVehicleEditPhoto(vehicleId, photoType, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehiclePlate(vehicleId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.carrierVehicleEditPlate(vehicleId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehiclePrimaryPhoto(vehicleId: string, photoType: VehiclePhotoType, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.carrierVehicleEditPrimaryPhoto(vehicleId, photoType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehicleRegistration(vehicleId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.carrierVehicleEditRegistration(vehicleId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehicleTag(vehicleId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.carrierVehicleEditTag(vehicleId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public vehicle(vehicleId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.carrierVehicleGet(vehicleId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public unassignDriver(vehicleId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierVehicleUnassignDriver(vehicleId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
